/*@ngInject*/
const DelayShowNextRequiredFieldModel = function () {
    let delayShowNextRequiredField = false;

    this.reset = function () {
        delayShowNextRequiredField = false;
    };

    this.setDelayShowNextRequiredField = function (value) {
        delayShowNextRequiredField = value;
    };

    this.isDelayShowNextRequiredField = function () {
        return delayShowNextRequiredField;
    };

};

angular.module('umFormViewer').service('delayShowNextRequiredFieldModel', DelayShowNextRequiredFieldModel);
